export default __webpack_public_path__ + "9512c13450155622b056ed284d4b2ff2.svg";